document.addEventListener('DOMContentLoaded', () => {
    const videoElement = document.querySelector('.outter.hero-video video');
    const playPauseButton = document.querySelector('.outter.hero-video button');

    if (videoElement && playPauseButton) {
        playPauseButton.addEventListener('click', () => {
            playPauseButton.classList.toggle('playing');
            if (playPauseButton.classList.contains('playing')) {
                videoElement.pause();
            } else {
                videoElement.play();
            }
        });

        videoElement.addEventListener('ended', () => {
            playPauseButton.classList.remove('playing');
        });
    } else {
        console.error('Video element or Play/Pause button not found!');
    }
});



// WEBPACK FOOTER //
// ./components/Hero-video/scripts/hero-video.js